import React from "react";
import { Box } from "@mui/material";
import { PageContainer } from "../../components/PageContainer";
import { Reports } from "./Reports";
import { DateRangeNav } from "./DateRangeNav";
import { useDateRange } from "./useDateRange";

const ActiveUsersPage = () => {
  const dateRange = useDateRange();
  const { startDate, endDate } = dateRange;

  return (
    <PageContainer title="Active Users">
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
        <DateRangeNav dateRange={dateRange} />
      </Box>
      <Reports startDate={startDate} endDate={endDate} />
    </PageContainer>
  );
};

export default ActiveUsersPage;
